import { Injectable } from '@angular/core';
import { CmsCurrentlyEditing } from '../_interfaces/cms';

@Injectable({
    providedIn: 'root',
})

export class CmsService {
    currentlyEditingContent: CmsCurrentlyEditing | null = null;
    constructor() { }

    setEditingContent(content: CmsCurrentlyEditing) {
        this.currentlyEditingContent = content;
        localStorage.setItem('cmsCurrentlyEditing', JSON.stringify(this.currentlyEditingContent));
    }

    getEditingContent(): CmsCurrentlyEditing | null {
        const cmsCurrentlyEditing = localStorage.getItem('cmsCurrentlyEditing');
        this.currentlyEditingContent = cmsCurrentlyEditing ? JSON.parse(cmsCurrentlyEditing) : null;
        return this.currentlyEditingContent;
    }
}
